import { showDeliverToGate } from "../config/envConfig";
import validator from "validator";
import { DATA_REFERENCE, DELIVERY_ENABLED } from "./Constants";
import apiList from "../services/apiList";
import { callApi } from "../services/callApi";

export const deleteAllCookies = () => {
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
};

export const getCookieCustom = (cName) => {
  const name = cName + "=";
  const cDecoded = decodeURIComponent(document.cookie); //to be careful
  const cArr = cDecoded.split("; ");
  let res;
  cArr.forEach((val) => {
    if (val.indexOf(name) === 0) res = val.substring(name.length);
  });

  return res;
};

export const setCookieCustom = (key, value) => {
  document.cookie = `${key}=${JSON.stringify(
    value
  )};max-age=${cookieValidity};path='/'`;
};

export const removeCookieCustom = (name) => {
  document.cookie = `${name}= ; expires = Thu, 01 Jan 1970 00:00:00 GMT`;
};

export const cookieValidity = 60 * 60 * 24 * 30;

export const isLoggedIn = () => {
  const kioskUser = getCookieCustom("kioskUser");
  if (kioskUser) return true;
  else return false;
};

export const formatRupees = (number) => {
  // Convert the number to a string
  const strNumber = number.toString();
  // Split the number into integer and decimal parts (if any)
  const parts = strNumber.split(".");
  let integerPart = parts[0];
  const decimalPart = parts[1] ? "." + parts[1] : "";

  // Add commas to the integer part
  const regex = /(\d)(?=(\d{3})+(?!\d))/g;
  integerPart = integerPart.replace(regex, "$1,");

  // Return the formatted rupees
  return integerPart + decimalPart;
};

export const size = {
  mobileS: "320px",
  mobileM: "375px",
  mobileP: "390px",
  mobileX: "414px",
  mobileL: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1440px",
  desktop: "2560px",
  kiosk: "1079px",
};

export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileP: `(min-width: ${size.mobileP})`,
  mobileX: `(min-width: ${size.mobileX})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet}) and (max-width: ${size.kiosk})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktop})`,
  kiosk: `(min-width: ${size.kiosk})`,
};

export const isTab = () => {
  if (
    window.matchMedia("screen and (min-width: 800px) and (max-width: 1079px)")
      .matches
  ) {
    return true;
  } else {
    return false;
  }
};

export const showDeliveryOption = () => {
  const data = JSON.parse(localStorage.getItem(DATA_REFERENCE));
  const fallbackDeliveryFlag = showDeliverToGate === "true";
  if (data && data[DELIVERY_ENABLED]) {
    if (data[DELIVERY_ENABLED]?.toLowerCase() === "yes") {
      return true;
    } else {
      return false;
    }
  } else {
    return fallbackDeliveryFlag;
  }
};

export const sendMessageToReactNative = (msg) => {
  if (window.ReactNativeWebView) {
    if (msg !== undefined) {
      window.ReactNativeWebView.postMessage(msg);
    }
  }
};

export const getUserInfo = async (type) => {
  try {
    let apiURL = apiList.user.info;
    let apiResponse;

    apiResponse = await callApi.get(apiURL);

    if (apiResponse.status === 200) {
      if (type === "metadata") {
        return apiResponse.metadata;
      } else if (type === "both") {
        return apiResponse;
      } else {
        return apiResponse.data;
      }
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export const applicablepromo = async (userId) => {
  try {
    let apiURL = apiList.user.getapplicablepromo;
    let apiResponse;

    apiResponse = await callApi.post(apiURL, {
      customerId: userId,
    });

    if (apiResponse.status === 200) {
      return apiResponse?.data;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
};

export const isEmailValid = (email) => {
  let res;
  if (validator.isEmail(email)) {
    res = true;
  } else {
    res = false;
  }
  return res;
};
